import { Filter } from "data/@types/GlobalSearchData";
import { fetchMeetingFields } from "./meetingFields";

export const createMeetingFilters = (caOfficeLocations: string[]): Filter[] => [
  {
    label: "Meeting ID",
    type: "numeric",
    field: "id",
  },
  {
    label: "Entity Legacy ID",
    type: "numeric",
    field: "entityLegacyId",
  },
  {
    label: "Entity RCU ID",
    type: "numeric",
    field: "entityId",
  },
  {
    label: "Scheduled By ID",
    type: "numeric",
    field: "scheduledById",
  },
  {
    label: "Meeting Link",
    type: "text",
    field: "meetingLink",
  },
  {
    label: "Entity Name",
    type: "text",
    field: "entityName",
  },
  {
    label: "Entity Type",
    type: "simple-select",
    options: ["Product", "Strategy", "Firm"],
    field: "entityType",
  },
  {
    label: "Universe",
    type: "checkbox-options",
    options: ["Public", "Private"],
    required: true,
    field: "universe",
  },
  {
    label: "Scheduled By",
    type: "text",
    field: "authorName",
  },
  {
    label: "Meeting Type",
    type: "select",
    fetchOptions: () => fetchMeetingFields().fetchMeetingTypeLookupValuesOnly(),
    field: "type",
  },
  {
    label: "Meeting Start Date/Time",
    type: "daterange",
    field: "startDateTime",
  },
  {
    label: "Meeting End Date/Time",
    type: "daterange",
    field: "endDateTime",
  },
  {
    label: "All Day Event",
    type: "boolean",
    field: "isAllDayEvent",
  },
  {
    label: "Annual Materials Received",
    type: "boolean",
    field: "annualMaterialsReceived",
  },
  {
    label: "Annual Notes Received",
    type: "daterange",
    field: "annualNotesReceived",
  },
  {
    label: "Invite Received Date",
    type: "daterange",
    field: "inviteReceivedDate",
  },
  {
    label: "No Comment Required",
    type: "boolean",
    field: "commentRequired",
    invertValue: true,
  },
  {
    label: "Closed/Private",
    type: "boolean",
    field: "closed",
  },
  {
    label: "Topic",
    type: "text",
    field: "topic",
  },
  {
    label: "Department",
    type: "select",
    fetchOptions: () => fetchMeetingFields().fetchDepartmentOwnerGroups(),
    field: "attendeeGroup",
  },
  {
    label: "Attendees TBD (AGM ONLY)",
    type: "boolean",
    field: "attendeeTbd",
  },
  {
    label: "CA Not Attending (AGM ONLY)",
    type: "boolean",
    field: "caNotAttending",
  },
  {
    label: "CA Leader(s)",
    type: "text",
    field: "caLeaders",
  },
  {
    label: "CA Participants",
    type: "text",
    field: "caParticipants",
  },
  {
    label: "Manager Participants",
    type: "text",
    field: "managerParticipants",
  },
  {
    label: "Responsible Writers",
    type: "text",
    field: "responsibleWriters",
  },
  {
    label: "Other Manager Representatives",
    type: "text",
    field: "otherManagers",
  },
  {
    label: "Other Meetings Attendees",
    type: "text",
    field: "otherMeetingAttendees",
  },
  {
    label: "Meeting Style",
    type: "select",
    fetchOptions: () =>
      fetchMeetingFields().fetchMeetingStyleLookupValuesOnly(),
    field: "style",
  },
  {
    label: "Meeting Location",
    type: "select",
    fetchOptions: () =>
      fetchMeetingFields().fetchMeetingLocationLookupValuesOnly(),
    field: "meetingLocation",
  },
  {
    label: "Office Location",
    type: "select",
    fetchOptions: () => Promise.resolve(caOfficeLocations),
    field: "caOffice",
  },
  {
    label: "Manager Location",
    type: "select",
    fetchOptions: () => fetchMeetingFields().fetchFirmLocations(),
    field: "managerLocation",
  },
  {
    label: "Other Location",
    type: "text",
    field: "otherLocation",
  },
  {
    label: "Other Country",
    type: "select",
    field: "otherCountry",
    fetchOptions: () => fetchMeetingFields().fetchOtherCountries(),
  },
  {
    label: "Created By",
    type: "text",
    field: "createdByPersonName",
  },
  {
    label: "Created Date",
    type: "daterange",
    field: "creTimest",
  },
  {
    label: "Last Modified By",
    type: "text",
    field: "updatedByPersonName",
  },
  {
    label: "Last Modified Date",
    type: "daterange",
    field: "modTimest",
  },
  { field: "createdById", label: "Created By ID", type: "numeric" },
  { field: "updatedById", label: "Last Modified By ID", type: "numeric" },
];
